exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_accept_appointment:hover {\r\n    opacity: 0.8; \r\n    cursor:pointer;\r\n}\r\n\r\n\r\n.btn_accept_appointment {\r\n    width: 120px;\r\n\twhite-space: nowrap;\r\n    background: #b202b2;\r\n    border: 0px;\r\n    color: white;\r\n    padding: 5px 0px;\r\n    cursor: pointer;\r\n}\r\n\r\n.btn_assign_appointment:hover {\r\n    opacity: 0.8; \r\n    cursor:pointer;\r\n}\r\n\r\n\r\n.btn_assign_appointment {\r\n    width: 120px;\r\n\twhite-space: nowrap;\r\n    background: #017dd8;\r\n    border: 0px;\r\n    color: white;\r\n    padding: 5px 0px;\r\n    cursor: pointer;\r\n    margin: 5px 0px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-search/usc-search.component.css
// module id = ../../../../../src/app/components/usc-store/usc-search/usc-search.component.css
// module chunks = main